<template>
  <div v-if="bookings && bookings.length">
    <div v-for="(booking, i) in bookings" :key="i">
      <v-card
        tile
        v-show="showSameDateOnlyOnce(formatDate(booking.startTime), i)"
        class="px-2 py-1 text-smaller font-weight-bold primary--text"
        :class="{ 'mt-0': i != 0 }"
        style="border-bottom-left-radius: 3px; border-bottom-right-radius: 3px"
        >{{ formatDate(booking.startTime) }}</v-card
      >

      <v-card tile class="my-1" @click="viewBookingDetails(booking)">
        <v-row no-gutters>
          <v-col class="col-3 flex-center-left-container">
            <v-img
              class="ma-1x"
              :src="
                booking.pax
                  ? `${branchImagePath}${booking.branchImageUrls[0]}`
                  : `${areaImagePath}${booking.areaImageUrls[0]}`
              "
              aspect-ratio="1"
              max-height="100"
              max-width="100"
            />
          </v-col>
          <v-col class="col-9 pl-4 pt-3x pr-4" style="padding-top: 7px;">
            <v-row no-gutters class="pb-1">
              <v-col class="text-title-medium text-title-black text-truncate">{{
                booking.pax
                  ? booking.branchName
                  : formatLocation(booking.area, booking.seat, booking.floor)
              }}</v-col>
            </v-row>

            <v-row
              no-gutters
              class="text-smaller"
              style="padding-bottom: 2px"
              :style="booking.pax ? 'margin-top: 0px' : null"
            >
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-clock-outline</v-icon>
                <!-- <v-icon class="icon-small">{{
                  booking.pax ? "mdi-human-handsdown" : "mdi-seat"
                }}</v-icon> -->
              </v-col>
              <v-col>{{
                formatPeriod(booking.startTime, booking.endTime)
              }}</v-col>
              <v-col v-if="booking.pax" class="col-4">
                <v-icon class="icon-small pr-1">mdi-account-multiple</v-icon>
                {{ booking.pax }}
              </v-col>
              <v-col v-else class="col-4">
                <v-icon class="icon-small pr-1">mdi-seat</v-icon>
                {{ booking.seat }}
              </v-col>
            </v-row>

            <v-row no-gutters class="text-xsmall-weight">
              <v-col class="col-1">
                <v-icon
                  :color="
                    formatBookingStatus(booking.actions, booking.pax).color
                  "
                  class="icon-small"
                  >{{
                    formatBookingStatus(booking.actions, booking.pax).icon
                  }}</v-icon
                >
              </v-col>
              <v-col class="text-uppercasex text-truncate-2lines">{{
                formatBookingStatus(booking.actions, booking.pax).text
              }}</v-col>
            </v-row>

            <!-- <v-row v-if="booking.pax" no-gutters class="text-small">
              <v-col class="col-1">
                <v-icon class="icon-small">mdi-account-multiple</v-icon>
              </v-col>
              <v-col>{{ booking.pax }}</v-col>
            </v-row> -->
          </v-col>
        </v-row>
      </v-card>
    </div>

    <!-- An invisible div fix the unknown flickering of the the shadow of the last card while tabs are being swipped left and right -->
    <div style="height: 1px; background: transparent"></div>
  </div>

  <v-container
    v-else
    style="height: 100%; text-align: center; word-wrap: break-word"
    class="primary--text flex-center-container text-title-black"
  >
    <NoItems label="No bookings" />
    <!-- <strong>No bookings</strong> -->
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import formatters from "@/helpers/formatters";
import constants from "@/helpers/constants";
import NoItems from "@/components/NoItems";

var appearedDate = [];

export default {
  name: "MyBookingList",
  components: {
    NoItems,
  },
  props: {
    bookings: Array,
  },
  data: () => ({
    appearedDate: [],
  }),
  methods: {
    ...mapMutations(["updateSelectedBooking"]),
    viewBookingDetails(booking) {
      this.updateSelectedBooking(booking);
      this.$router.push({ name: "MyBookingDetails" });
    },
    formatLocation(area, seat, floor) {
      return formatters.formatLocation(area, seat, floor);
    },
    formatPeriod(fromDateString, toDateString) {
      return formatters.formatPeriod(fromDateString, toDateString);
    },
    formatDate(dateString) {
      return formatters.formatDate(dateString);
    },
    formatBookingStatus(actions, isVisitBooking) {
      return formatters.formatBookingStatus(actions, isVisitBooking);
    },
    showSameDateOnlyOnce(date, arrayIndex) {
      let show = true;
      // const appearedDate = this.appearedDate;

      if (arrayIndex === 0) {
        appearedDate = [];
      }

      if (appearedDate && appearedDate.includes(date)) {
        show = false;
      } else {
        appearedDate.push(date);
      }

      // console.log(show, date, JSON.stringify(appearedDate));
      return show;
    },
  },
};
</script>

<style scoped>
.text-truncate-2lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
